exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pointer{cursor:pointer}.exclamationmark{width:16px;height:16px}.btn.btn-outline-primary.dwm{padding:.375rem .75rem;color:#fff}.btn-check:active+.btn-outline-primary.dwm,.btn-check:checked+.btn-outline-primary.dwm,.btn-outline-primary.dwm.active,.btn-outline-primary.dwm.dropdown-toggle.show,.btn-outline-primary.dwm:active{color:#fff!important;background-color:#0d6efd;border-color:#0d6efd}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-456226aa","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/main/naverad/DashBoard.vue
// module id = 313
// module chunks = 0